import { useContext } from 'react';

import { BottomViewsContext } from '../contexts';

export const useBottomViewsContext = () => useContext(BottomViewsContext);
